<template>
  <div class="header-wrap">
    <header class="header">
      <div class="header-inner">
        <div class="left">
          <router-link to="/">
            <div class="logo-wrap">
              <img src="@/assets/images/logo.png" class="logo">
              <h1>飞飞盘</h1>
            </div>
          </router-link>
          <div class="form-wrap">
            <div class="search-form">
              <!-- <div class="search-way">
                <template>
                  <p class="default" @click.stop="choosePanel = !choosePanel">{{ WAYS[searchWay]}}</p>
                  <img src="@/assets/images/arrow.png" @click.stop="choosePanel = !choosePanel" class="arrow"> 
                </template>
                <div class="choose-wrap" v-show="choosePanel">
                  <p class="choose-item" v-for="(item, index) in WAYS" :key="item" @click="chooseWay(index)">{{item}}</p>
                </div>
              </div> -->
              <input autocomplete="off" type="text" placeholder="请输入你要搜索的关键词" class="input" @click.stop="" @keyup.enter="submit" v-model="keyword" autofocus>
              <span class="search-button" @click="submit"> </span>
            </div>
          </div>
        </div>
        <div class="right">
          <!-- <van-button v-if="!userinfo" @click="showLogin" type="primary" size="small">登录</van-button> -->
          <!-- <img v-if="userinfo" @click="showInfoMask" :src="userinfo.avatar" class="avatar" alt=""> -->
          <span v-if="userinfo" @click="showInfoMask" class="cookie">本站Cookie信息</span>
        </div>
      </div>
    </header>
    <van-dialog class="info-dialog" v-model="infomask" :before-close="closeMask" confirm-button-text="确定"  >
      <div class="content" v-if="userinfo">
        <!-- <h4>{{userinfo.nickname}}</h4> -->
        <p class="uid">UID：{{userinfo.unionid}}</p>
        <!-- <div class="vipinfo">
          <div class="left">
            <p class="em">线路：{{WAYS[userinfo.vipgrade]}}</p>
            <p v-if="!userinfo.expiredate" class="success">有效期：永久</p>
            <p v-if="userinfo.expiredate && userinfo.expired" class="danger">有效期：{{userinfo.expiredate | formatDate}}</p>
            <p v-if="userinfo.expiredate && !userinfo.expired" class="success">有效期：{{userinfo.expiredate | formatDate}}</p>
          </div>
          <van-button size="mini" round v-if="userinfo.vipgrade == 0" type="primary" @click="upgrade">升级线路</van-button>
          <van-button size="mini" round v-if="!userinfo.vipgrade == 0" type="primary" @click="upgrade">立即续费</van-button>
        </div> -->
        <p class="logout tip"><a href="javascript:void(0);" @click="logout">清除Cookie退出</a> </p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { logout } from "@/api/user"
export default {
   data () {
    return {
      keyword: '',
      isFrame: false,
      infomask: false,
      choosePanel: false,
    }
  },
  mounted () {
    if (window.self != window.top) {
      this.isFrame = true
    }
  },
  methods: {
    submit () {
      if (this.isFrame) {
        return this.openWindow(`${window.location.origin}/#/main/search?keyword=${encodeURIComponent(this.keyword)}`, true)
      }
      return window.location.href = `${window.location.origin}/#/main/search?keyword=${encodeURIComponent(this.keyword)}`
    },
    chooseWay (index) {
      if (!this.userinfo) {
        this.$toast.fail('请先登录')
        this.choosePanel = false
        return setTimeout(() => {
          this.showLogin()
        }, 500)
      }

      if (this.userinfo && this.userinfo.vipgrade < index) {
        this.choosePanel = false
        this.$toast.fail('请先升级线路')
        return setTimeout(() => {
          this.showPayDialog()
        }, 500)
      }

      this.choosePanel = false
      this.updateSearchWay(index)
    },
    async logout () {
      const res = await logout()
      if (res.code == 0) {
        this.$toast.success('退出成功')
        window.location.reload()
      } else {
        return this.$toast.fail('稍后重试')
      }
    },
    async showLogin () {
      this.showLoginDialog()
    },
    closeMask (_, done) {
      this.infomask = false
      done()
    },
    async showInfoMask () {
      await this.updateUserinfo()
      this.infomask = true
    },
    upgrade () {
      this.showPayDialog()
      this.infomask = false
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_base.scss";
@import "@/assets/scss/_var.scss";
.header-wrap {
  height: 61px;
}
.header {
  position: fixed;
  top:0;
  left:0;
  right: 0;
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  z-index: 10;
  .header-inner {
    width: $theme-width;
    margin: 0 auto;
    display: flex;
    max-width: 100%;
    justify-content: space-between;
    align-items: center;
    a {
      text-decoration: none;
    }
    .left, .right {
      display: flex;
      align-items: center;
    }
    .logo-wrap {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 10px;
      .logo {
        height: 26px;
        width: auto;
        margin-right: 5px;
      }
      h1 {
        font-size: 1.6rem;
        flex-shrink: 0;  // 解决 safari 下面样式问题
        color: $theme-color;
      }
    }
    .form-wrap {
      width: 500px;
      max-width: 100%;
      .search-form {
        position: relative;
        display: inline-block;
        width: 100%;
        &:hover {
          .input {
            border-color: rgba(223, 225, 229, 1);
          }
        }
        .search-way {
          position: absolute;
          top: 1px;
          width: 140px;
          left: 1px;
          bottom: 1px;
          z-index: 100;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #F5F5F5;
          border-right: 1px solid #ddd;
          .arrow {
            height: 6px;
            margin-left: 2px;
          }
          .choose-wrap {
            position: absolute;
            top: 100%;
            left: -1px;
            right: -1px;
            background-color: #fff;
            border: 1px solid #ddd;
            .choose-item {
              padding: 10px 0;
              border-bottom: 1px solid #ddd;
              text-align: center;
              &:hover {
                color: $theme-color;
              }
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
        .input {
          width: 100%;
          font-size: 13px;
          height: 36px;
          padding-left: 150px;
          padding-right: 40px;
          outline: none;
          border: 1px solid #ddd;
          transition: all ease 0.3s;
          &:focus {
            border-color: $theme-color;
          }
        }
        .search-button {
          display: inline-block;
          position: absolute;
          bottom: 5px;
          width: 40px;
          right: 5px;
          top: 5px;
          z-index: 2;
          outline: none;
          border: none;
          cursor: pointer;
          background-color: $theme-color;
          border-radius: 4px;
          transition: all ease 0.2s;
          background: $theme-color url('../assets/images/search.png') no-repeat center center;
          background-size: 14px 14px;
          &:hover {
            background-color: darken($theme-color, 5%);
          }
          &:active {
            background-color: darken($theme-color, 10%);
          }
        }
      }
    }

    .van-button {
      padding: 0 10px;
    }

    .avatar {
      cursor: pointer;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      border: 1px solid #ddd;
    }
    .cookie {
      font-size: 12px;
      color: #666;
      cursor: pointer;
    }
  }
}

.van-dialog {
  .content {
    text-align: center;
    padding: 20px 20px 10px 20px;
  }
  .qrcode {
    width: 200px;
    height: 200px;
  }
  .tip {
    font-size: 13px;
    color: #666;
    &.logout {
      margin-top: 15px;
    }
    a {
      font-size: 13px;
      margin-top: 10px;
    }
  }
  &.info-dialog {
    .uid {
      font-size: 12px;
      margin-top: 10px;
    }
    .vipinfo {
      margin: 15px 0;
      padding: 10px;
      border-radius: 4px;
      background-color: rgba($theme-color, 0.2);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      text-align: left;
      .em {
        margin-bottom: 5px;
      }
      .van-button {
        padding: 0 10px;
      }
    }
  }
}

@media (max-width: 700px) {
  .header-wrap {
    height: 57px;
  }
  .header {
    padding: 10px 5px;
    .header-inner {
      .logo-wrap {
        .logo {
          height: 20px;
          margin-right: 0;
        }
        h1 {
          display: none;
        }
      }
      .form-wrap {
        width: 280px;
        .search-way {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
